<template>
    <div class="TicketLoadItem">
        <div class="column">{{ load.number }}</div>
        <div class="column">
            <TicketLoadItemTimes :start="load.loadSiteArriveAt" :end="load.loadSiteLeaveAt"/>
        </div>
        <div class="column">
            <TicketLoadItemTimes :start="load.dumpSiteArriveAt" :end="load.dumpSiteLeaveAt"/>
        </div>
        <div class="column">{{ load.tons | formatTons }}</div>
        <div class="column">
            <a v-if="load.photo" :href="photoUrl" target="_blank" class="attachment">
                <Icon name="image"/>
                <span>Image</span>
            </a>
        </div>
        <div class="column">
            <Button class="link" @click="$emit('edit')">Edit</Button>
            <span> | </span>
            <Button class="link danger" @click="$emit('remove')">Delete</Button>
        </div>
    </div>
</template>

<script>
import TicketLoadItemTimes from './TicketLoadItemTimes';
import { getApiImgPath } from '@/utils/formatting';

export default {
    name: 'TicketLoadItem',

    components: { TicketLoadItemTimes },

    props: {
        load: { type: Object, required: true },
        index: { type: Number, required: true },
    },

    computed: {
        photoUrl() {
            return getApiImgPath(this.load.photo);
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.TicketLoadItem {
    display: flex;
    align-items: center;
    padding: 0 $grid-gutter-width;
    height: 55px;

    &:not(:last-child) {
        border-bottom: 1px solid $divider-color;
    }

    .column {
        @extend %ticket-load-column;
    }

    .attachment {
        display: flex;
        align-items: center;

        .Icon {
            margin-right: 5px;
        }
    }

    .Button {
        height: auto;
        padding: 0;
        line-height: 1;
    }
}
</style>
